// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__d8WAm","logoLink":"Navbar_logoLink__CBgAT","bold":"Navbar_bold__cXe27","links":"Navbar_links__GD5H0","link":"Navbar_link__pRvHI"};